const founderMixin = (founderName, founderTitle, founderMotto, founderImg, founderApi) => ({
  data() {
    return {
      info: {
        name: this.$t(founderName),
        title: this.$t(founderTitle),
        motto: this.$t(founderMotto),
        description: '',
        img: founderImg,
      },

      breadcrumbs: [
        {
          title: this.$t('components.main.navigation.about.us.about-airalo'),
          link: '/about-us/about-airalo',
        },
        {
          title: this.$t(founderName),
        },
      ],
    }
  },
  async fetch() {
    try {
      const responseData = await this.$store.dispatch('fetch_contents_page', founderApi)

      if (responseData?.content) {
        this.info.description = responseData.content
      }
    } catch (err) {}
  },
})

export default founderMixin
